import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getModelosPanel = async (searchTerm, page, perPage) => {
    let queryParams = [];
    if (searchTerm) {
        queryParams.push(`mod_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';
    return await getData("/modelos", queryString);
}

export const getModeloById = async (id) => {
    const res = await getData(`/modelos/${id}`)
    return res
}

export const postModelo = async (body) => {
    const res = await postData('/modelos', body)
    return res
}

export const patchModelo = async (id, body) => {
    const res = await patchData(`/modelos/${id}`, body)
    return res
}

export const deleteModelo = async (id) => {
    const res = await deleteData(`/modelos/${id}`)
    return res
}